import React, { useContext } from 'react';

import { showLogNoTime } from '@libs/NwMoment';
import { getVideoCover } from '@libs/NwUtils';

import { ListContext } from '@contexts/ListContext';

import NwIcon from '@components/Gui/NwIcon';
import { NwTag } from '@components/Gui/NwTag';

import { MediaItem } from './ModelDetailsMediaUI';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ModelMediaItem = ({ media, type, onMediaClicked }) => {
    const { GetUserNameShort } = useContext(ListContext);
    const coverUrl = type == 'video' ? getVideoCover(media) : media.Thumbnail ? media.Thumbnail.Url : null;

    const MediaDescriptors = ({ media }) => {
        let line1 = GetUserNameShort(media.UserCreated) + ', ' + showLogNoTime(media.DateCreated);
        let line2 = '';
        if (media.Notes) {
            line2 += media.Notes.substring(0, 80);
            if (media.Notes.length > 79) {
                line2 += '(...)';
            }
        }
        return (
            <>
                <p>{line1}</p>
                <p>{line2}</p>
            </>
        );
    };

    const getItemStyle = () => {
        const style = {};
        if (coverUrl) {
            style.backgroundImage = `url(${coverUrl})`;
        } else {
            if (type === 'video') {
                style.backgroundColor = 'black';
            }
        }
        return style;
    };

    let typeForClass = type === 'video' && media.caption === 'ENCODING VIDEO' ? 'encoding-video' : type;

    const handleClick = () => {
        // if (media.caption !== 'ENCODING VIDEO') {
            if (onMediaClicked) {
                onMediaClicked(media);
            }
        // }
    };

    return (
        <MediaItem
            className={typeForClass}
            onClick={handleClick}
            style={{ width: media.thumbnailWidth, height: media.thumbnailHeight }}
        >
            {media.caption !== 'ENCODING VIDEO' && (
                <div className="overlay">
                    <div className="text-container">
                        <MediaDescriptors media={media} />
                    </div>
                </div>
            )}
            <div className="cover-container" style={getItemStyle()}>
                {media.caption === 'ENCODING VIDEO' ? (
                    <div className="icons-container">
                        <h1>Encoding video</h1>
                        <small>Please wait...</small>
                        <NwIcon icon={byPrefixAndName.fasl['camera-movie']} beat />
                    </div>
                ) : (
                    <>
                        <div className="icons-container">
                            {type === 'video' && (
                                <>
                                    <span>
                                        <NwIcon icon={byPrefixAndName.fass['play']} />
                                    </span>
                                    {media.Provider === 'Vimeo' && (
                                        <span>
                                            <NwIcon icon={byPrefixAndName.fab['vimeo']} />
                                        </span>
                                    )}
                                    {media.Provider === 'Youtube' && (
                                        <span>
                                            <NwIcon icon={byPrefixAndName.fab['youtube']} />
                                        </span>
                                    )}
                                </>
                            )}
                        </div>
                        <div className="tags-container">
                            {media.Tags.map((tag) => {
                                return (
                                    <NwTag type="dark" key={tag}>
                                        {tag}
                                    </NwTag>
                                );
                            })}
                        </div>
                    </>
                )}
            </div>
        </MediaItem>
    );
};

export default ModelMediaItem;
